// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d8n8","left":"styles_left__2BYeJ"};